import Swiper from "swiper/bundle";

function createBannerSlider() {
    const container = document.querySelector(".banner-slider");
    if (!container) return;

    const swiperElement = container.querySelector('.swiper');
    const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        
         
    });



}

export { createBannerSlider };
